import React from "react";

type Props = {
  itemKey?: string; // X position in the sprite sheet
  width?: number;
  height?: number;
};

export default function CardGameItem({
  itemKey = "property",
  width = 100,
  height = 100,
}: Props) {
  console.log("itemKey:::", itemKey);

  const _scale = 4;

  const itemsImage = "/images/component.png";
  const level_1 = {
    panda: {
      x: 200 * _scale,
      y: 220 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    property: {
      x: 140 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    money_bag: {
      x: 200 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    car: {
      x: 260 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    money: {
      x: 320 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    crown: {
      x: 380 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    gift: {
      x: 440 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    point: {
      x: 10 * _scale,
      y: 220 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    _null: {
      x: 80 * _scale,
      y: 220 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    l3card: {
      x: 80 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
    l4card: {
      x: 10 * _scale,
      y: 150 * _scale,
      width: 60 * _scale,
      height: 60 * _scale,
    },
  };

  const item = level_1[itemKey as keyof typeof level_1];
  const scale = width / item.width;

  return (
    <div
      style={{
        width: width,
        height: height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden", // ensure clipping works in Safari
      }}
    >
      <div
        style={{
          minWidth: item.width,
          width: item.width,
          minHeight: item.height,
          height: item.height,
          overflow: "hidden",
          position: "relative",
          transform: `scaleX(${scale}) scaleY(${scale})`,
          transformOrigin: "center",
          WebkitTransformStyle: "preserve-3d",
          WebkitBackfaceVisibility: "hidden",
          WebkitMaskImage: "radial-gradient(white, black)", // Safari clipping fallback
        }}
      >
        {/* Background-sprite avoids creating many individual decoded <img> textures which reduces Android memory pressure. */}
        <div
          aria-hidden={false}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: item.width,
            height: item.height,
            display: "block",
            backgroundImage: `url(${itemsImage})`,
            backgroundPosition: `-${item.x}px -${item.y}px`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "auto",
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            maxWidth: "none",
            maxHeight: "none",
            transform: "translate3d(0,0,0)",
            WebkitTransform: "translate3d(0,0,0)",
          }}
        />
      </div>
    </div>
  );
}
